import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { LayoutGrid, Compass, Columns3, UserRound, Sparkles, LogOut } from "lucide-react";

const navItems = [
  { to: "/app", label: "Dashboard", icon: LayoutGrid, testid: "nav-dashboard" },
  { to: "/app/discover", label: "Discover", icon: Compass, testid: "nav-discover" },
  { to: "/app/pipeline", label: "Pipeline", icon: Columns3, testid: "nav-pipeline" },
  { to: "/app/profile", label: "Profile", icon: UserRound, testid: "nav-profile" },
];

export default function Layout() {
  const location = useLocation();
  return (
    <div className="min-h-screen flex bg-[#0A0A0A] text-[#EDEDED]">
      {/* Sidebar */}
      <aside className="w-[240px] shrink-0 border-r border-[#222] flex flex-col" data-testid="sidebar">
        <Link
          to="/app"
          data-testid="brand-link"
          className="px-6 py-8 border-b border-[#222] block hover:bg-[#121212] transition-colors"
        >
          <div className="font-serif text-3xl leading-none">
            Vantage<span className="text-[#CCFF00]"> </span>Hub
          </div>
          <div className="uppercase-mono mt-3 text-[#555]">v0 · single-user</div>
        </Link>

        <nav className="flex-1 py-6">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to || (item.to !== "/app" && location.pathname.startsWith(item.to));
            return (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={`flex items-center gap-3 px-6 py-3 border-l-2 transition-colors text-sm ${
                  active
                    ? "border-[#CCFF00] text-[#CCFF00] bg-[#121212]"
                    : "border-transparent text-[#8a8a8a] hover:text-[#ededed] hover:bg-[#121212]"
                }`}
              >
                <Icon size={16} strokeWidth={1.5} />
                <span className="uppercase tracking-widest text-[11px]">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <Link
          to="/app/discover"
          data-testid="sidebar-cta-discover"
          className="m-6 mt-0 px-4 py-3 btn-accent flex items-center justify-center gap-2 text-[12px] uppercase tracking-widest"
        >
          <Sparkles size={14} strokeWidth={1.5} />
          New Discovery
        </Link>
        <button
          onClick={() => window.__mls_lock?.()}
          data-testid="sidebar-lock-btn"
          className="mx-6 mb-6 px-4 py-2 border border-[#222] hover:border-[#FF3333] hover:text-[#FF3333] transition-colors text-[11px] uppercase tracking-widest text-[#8a8a8a] flex items-center justify-center gap-2"
          title="Lock this workspace and require the password on next visit"
        >
          <LogOut size={12} strokeWidth={1.5} />
          Lock workspace
        </button>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
